<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   viewBox="0 0 96.734901 35.893242"
   version="1.1"
   xml:space="preserve"
   id="svg45"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
    
<path
   fill="none" stroke="#979595" stroke-width="4.167" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="2"
   d="m 2223.3774,1433.0583 5.4583,-7.1862 a 22.206404,22.206404 0 0 1 35.3674,0 l 5.4583,7.1862 5.3898,7.0529 a 22.342311,22.342311 5.9723332e-5 0 0 35.5042,0 l 5.3899,-7.0529"
   transform="translate(-2221.2939,-1415.046)" /></svg>
